import { render } from "./Vision.vue?vue&type=template&id=54c8afe9&scoped=true"
const script = {}

import "./Vision.vue?vue&type=style&index=0&id=54c8afe9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54c8afe9"

export default script